import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useQuery } from '../hooks/useQuery';
import { useForm, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import { useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../hooks/useSnackbar';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { cryptedParam, decryptData, decryptedParam } from '../utils';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export const Step3Cadastro = ({
  activeStep,
  setActiveStep,
  fornecedor,
  setFornecedor,
}) => {
  const [mask, setMask] = React.useState('(99) 99999-9999');
  const [mask2, setMask2] = React.useState('(99) 99999-9999');
  const [loading, setLoading] = React.useState(false);
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const { cadastroStep3, showCadastroFornecedor } = useQuery();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isRascunho, setIsRascunho] = React.useState(false);
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }
      preencherFormulario(fornecedor_id);
    }
  }, []);

  const preencherFormulario = async (id) => {
    try {
      setLoading(true);
      const result = await showCadastroFornecedor(id);

      if (result && result.data && result.data.data) {
        setFornecedor(result.data.data);

        setValue('telefone', result.data.data.telefone);
        setValue('telefone_adicional', result.data.data.telefone_adicional);
        setValue('email', result.data.data.email);
      }
      setLoading(false);
    } catch (error) {
      navigate('/dashboard/listar-cadastros');
    }
  };

  const onSubmit = (data) => {
    data = { ...fornecedor, ...data };
    cadastrarFornecedor(data);
  };

  const cadastrarFornecedor = async (data) => {
    const result = await cadastroStep3(data);
    if (result && result.data && result.data.data) {
      setFornecedor(result.data.data);
      if (isRascunho) {
        if (isUsuarioSebrae) {
          navigate('/dashboard/listar-cadastros');
        } else {
          if (result.data.data.cnpj == null) {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${result.data.data.cnpj}`,
              { replace: true },
            );
          } else {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${result.data.data.cpf}`,
              { replace: true },
            );
          }
        }
        snackbar.showSnackbar('Rascunho salvo com sucesso.');
      } else {
        if (result.data.data.tipo === 'PJ') {
          setActiveStep(activeStep + 1);
        } else {
          setActiveStep(activeStep + 2);
        }
      }
    }
  };

  const onErrors = () => {};

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress style={{ marginTop: 60 }} />
        </Box>
      ) : (
        <Grid container spacing={2} padding={2}>
          <Grid container sm={12} item>
            <p style={{ fontSize: 20, width: '100%', margin: 0 }}>
              <b>Cadastrar</b>
            </p>
            <p style={{ fontSize: 16, width: '100%' }}>
              Por favor, informe seus dados de contato
            </p>
          </Grid>
          <Grid container sm={12} item>
            <p style={{ fontSize: 16 }}>
              <b>Contato</b>
            </p>
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Telefone 1:</label>
            <Controller
              name="telefone"
              control={control}
              rules={{ required: 'Telefone é obrigatório' }}
              mask={mask}
              render={({
                field: { onChange, ref, value },
                fieldState: { error },
              }) => (
                <InputMask
                  style={{ marginTop: '5px' }}
                  mask={mask}
                  maskChar={'_'}
                  onBlur={(e) => {
                    const v = e.target.value.replace(/\D/g, '');
                    if (v.length === 10) {
                      setMask('(99) 9999-9999');
                    } else {
                      setMask('(99) 99999-9999');
                    }
                  }}
                  onFocus={(e) => {
                    setMask('(99) 99999-9999');
                  }}
                  onChange={onChange}
                  value={value}
                >
                  {(inputProps) => (
                    <TextField
                      margin="normal"
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                      {...inputProps}
                      id="telefone"
                      placeholder="Digite o telefone com DDD"
                    />
                  )}
                </InputMask>
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Telefone 2:</label>
            <Controller
              name="telefone_adicional"
              control={control}
              mask={mask}
              render={({
                field: { onChange, ref, value },
                fieldState: { error },
              }) => (
                <InputMask
                  style={{ marginTop: '5px' }}
                  mask={mask2}
                  maskChar={'_'}
                  onBlur={(e) => {
                    const v = e.target.value.replace(/\D/g, '');
                    if (v.length === 10) {
                      setMask2('(99) 9999-9999');
                    } else {
                      setMask2('(99) 99999-9999');
                    }
                  }}
                  onFocus={(e) => {
                    setMask2('(99) 99999-9999');
                  }}
                  onChange={onChange}
                  value={value}
                >
                  {(inputProps) => (
                    <TextField
                      margin="normal"
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                      {...inputProps}
                      id="telefone2"
                      placeholder="Digite o telefone com DDD"
                    />
                  )}
                </InputMask>
              )}
            />
          </Grid>
          <Grid container sm={12} item>
            <label style={{ color: '#707070' }}>E-mail:</label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Email é obrigatório',
                pattern: {
                  value:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: 'Insira um e-mail válido',
                },
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  margin="normal"
                  value={value}
                  error={error}
                  helperText={error && error.message}
                  onChange={onChange}
                  fullWidth
                  placeholder="Digite o e-mail"
                />
              )}
            />
          </Grid>
        </Grid>
      )}
      {loading ? null : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            justifyContent: 'space-between',
            marginBottom: '-50px',
          }}
        >
          <Button
            type="submit"
            variant="text"
            color="primary"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              setActiveStep(activeStep - 1);
            }}
          >
            <ArrowBackIosIcon color="primary" />
            Voltar
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              pt: 2,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="warning"
              F
              style={{ marginRight: '0.5rem' }}
              onClick={() => {
                setIsRascunho(true);
              }}
            >
              Salvar como rascunho
              <SaveIcon />
            </Button>
            <Button
              type="submit"
              variant="contained"
              onClick={() => {
                setIsRascunho(false);
              }}
            >
              Próximo
            </Button>
          </Box>
        </Box>
      )}
    </form>
  );
};
